import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { Country, Nationality } from '@app/shared/models/country.model';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private http: HttpClient) { }

  getCountries(): Observable<Country[]> {
    return this.http
      .get<Country[]>(`${environment.apiEndpoint}/countries`);
  }

  getNationalities(): Observable<Nationality[]> {
    return this.http
      .get<Country[]>(`${environment.apiEndpoint}/countries/nationalities`);
  }
}
